export default [
    {
        name: 'queryCorperateLists',
        url: '/lists'
    },
    {
        name: 'deleteCorperate',
        url: '/delete'
    },
    {
        name: 'updateCorperate',
        url: '/update'
    }
];
